import AuthService from "../services/AuthService/AuthService";
import moment from 'moment';

export const convertToDateFormat = (date, format, hasTime = true) => {
    const d = new Date(date);
    if (isNaN(d)) {
        return date;
    }
    const yyyy = d.getFullYear();
    let mm = addZero(d.getMonth() + 1); // Months start at 0!
    let dd = addZero(d.getDate());
    let time = `${addZero(d.getHours())}:${addZero(d.getMinutes())}:${addZero(d.getSeconds())}`;

    if (format) {
        format = format.replace("MM", mm.toString());
        format = format.replace("dd", dd.toString());
        format = format.replace("yyyy", yyyy.toString());

        return hasTime ? `${format} ${time}` : format;
    } else {
        return d.toLocaleString();
    }

    function addZero(t) {
        if (t < 10) {
            return '0' + t;
        }
        return t;
    }
}

export const conditionalOperators = {
    "eq": {
        "text": "equals",
        "value": "eq"
    },
    "neq": {
        "text": "does not equal",
        "value": "neq"
    },
    "gt": {
        "text": "greater than",
        "value": "gt"
    },
    "lt": {
        "text": "less than",
        "value": "lt"
    },
    "ct": {
        "text": "contains",
        "value": "ct"
    },
    "nct": {
        "text": "does not contain",
        "value": "nct"
    },
    "sw": {
        "text": "starts with",
        "value": "sw"
    },
    "nsw": {
        "text": "does not start with",
        "value": "nsw"
    },
    "ew": {
        "text": "ends with",
        "value": "ew"
    },
    "new": {
        "text": "does not end with",
        "value": "new"
    },
    "t": {
        "text": "is true",
        "value": "t"
    },
    "nt": {
        "text": "is not true",
        "value": "nt"
    },
    "e": {
        "text": "is exists",
        "value": "e"
    },
    "ne": {
        "text": "is not exist",
        "value": "ne"
    }
}

export const convertToOnlyDateFormat = (date, format, hasTime = true) => {
    const d = new Date(date);
    if (isNaN(d)) {
        return date;
    }
    const yyyy = d.getFullYear();
    let mm = addZero(d.getMonth() + 1); // Months start at 0!
    let dd = addZero(d.getDate());

    if (format) {
        format = format.replace("MM", mm.toString());
        format = format.replace("dd", dd.toString());
        format = format.replace("yyyy", yyyy.toString());

        return format;
    } else {
        return d.toLocaleString();
    }

    function addZero(t) {
        if (t < 10) {
            return '0' + t;
        }
        return t;
    }
}

export const isFloat = (n) => {
    return Number(n) === n && n % 1 !== 0;
}

export const isInt = (n) => {
    return Number(n) === n && n % 1 === 0;
}

export const getExtension = (filename) => {
    let parts = filename.split(".");
    return parts[parts.length - 1];
};

export const hasSubItemsPermission = (permissionList, tag, subitems) => {
    if (subitems) {
        for (let i of subitems) {
            if (permissionList?.includes(i.tag)) {
                return true;
            }
        }
        return false;
    }
    return permissionList?.includes(tag);
};

export const setServiceMessage = (data, prefix) => {
    let suffix = data.message;
    data.message = prefix + suffix;
    return data;
};

export const capitalizeFirstLetter = (string) => {
    return string.replace(/^./, string[0].toUpperCase());
}

export const getCaretPosition = (element) => {
    let position = 0;
    const isSupported = typeof window.getSelection !== "undefined";
    if (isSupported) {
        const selection = window.getSelection();
        // Check if there is a selection (i.e. cursor in place)
        if (selection.rangeCount !== 0) {
            // Store the original range
            const range = window.getSelection().getRangeAt(0);
            // Clone the range
            const preCaretRange = range.cloneRange();
            // Select all textual contents from the contenteditable element
            preCaretRange.selectNodeContents(element);
            // And set the range end to the original clicked position
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            // Return the text length from contenteditable start to the range end
            position = preCaretRange.toString().length;
        }
    }
    return position;
};

export const findElementName = (flow, currentName) => {
    let count = 0;
    let value;
    for (const item of flow) {
        if ((item.type === "autom" || item.type === "process") && item.fields) {
            value = item.fields.elementName?.value;
            if (value === currentName) {
                count += 1;
                if (count > 1) {
                    return true;
                }
            }
        }
    }
    return false;
};

//type process or autom
export const getAutomNamesIDs = (flow) => {
    let data = [];
    let name;
    let id;

    for (const item of flow) {
        if ((item.type === "autom" || item.type === "process") && item.fields) {
            id = item.fields.autom?.value;
            name = item.fields.elementName?.value;
            if (name && id) {
                data.push({ id, name });
            }
        }
    }
    return data;
};


export const flowMouseWheelListener = () => {
    const el = document.getElementById("alt-area");
    el.addEventListener("wheel", (event) => {
        const flow = document.getElementById("drag-me");
        const delta = Math.sign(event.deltaY);
        const offsetChangeValue = 64;
        const topPosition = document.getElementById("drag-me").offsetTop;

        if (delta === -1)
            flow.style.top = (topPosition + offsetChangeValue).toString() + "px";
        else flow.style.top = (topPosition - offsetChangeValue).toString() + "px";
    });
};

export const checkEquality = (array, variables, forLoopCount) => {
    let attributes = [];
    for (let i = 0; i < forLoopCount; i++) {
        let attribute = {};
        if (array[i].name !== variables.attributes[i].name) {
            attribute.connection_attribute_id = variables.attributes[i].id;
            if (!attribute.willBeUpdatedFields) {
                attribute.willBeUpdatedFields = [
                    {
                        field_name: "name",
                        field_value: array[i].name,
                    },
                ];
            } else {
                attribute.willBeUpdatedFields.push({
                    field_name: "name",
                    field_value: array[i].name,
                });
            }
        }

        if (array[i].description !== variables.attributes[i].description) {
            attribute.connection_attribute_id = variables.attributes[i].id;

            if (!attribute.willBeUpdatedFields) {
                attribute.willBeUpdatedFields = [
                    {
                        field_name: "description",
                        field_value: array[i].description,
                    },
                ];
            } else {
                attribute.willBeUpdatedFields.push({
                    field_name: "description",
                    field_value: array[i].description,
                });
            }
        }

        //if there is no any change input, I will have to add current switch states to array beacause couldn't check equalty of true false statement...
        attribute.connection_attribute_id = variables.attributes[i].id;
        if (!attribute.willBeUpdatedFields) {
            attribute.willBeUpdatedFields = [
                {
                    field_name: "masked_flag",
                    field_value: array[i].masked_flag,
                },
                {
                    field_name: "user_provided_flag",
                    field_value: array[i].user_provided_flag,
                },
            ];
        } else {
            attribute.willBeUpdatedFields.push(
                {
                    field_name: "masked_flag",
                    field_value: array[i].masked_flag,
                },
                {
                    field_name: "user_provided_flag",
                    field_value: array[i].user_provided_flag,
                }
            );
        }

        attributes = [...attributes, attribute];
    }

    return attributes;
};

export const isChecked = (
    catName,
    id,
    setFilter,
    filter,
    setTempChipList,
    tempChipList,
    item
) => {
    let copyFilter = { ...filter };
    if (catName === "Category") {
        if (!filter?.category_id) {
            copyFilter = { ...copyFilter, category_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                category_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.category_id = [...copyFilter.category_id, id]
            setFilter(copyFilter, copyFilter.category_id);
            tempChipList.category_id = [
                ...tempChipList.category_id,
                {
                    item_name: item.name,
                    item_id: id
                }
            ]
            setTempChipList(tempChipList, tempChipList.category_id);
        }
    } else if (catName === "Business Process") {
        if (!filter?.business_process_id) {
            copyFilter = { ...copyFilter, business_process_id: [id] }
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                business_process_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.business_process_id = [...copyFilter.business_process_id, id]
            setFilter(copyFilter, copyFilter.business_process_id);
            tempChipList.business_process_id = [...tempChipList.business_process_id,
            { item_name: item.name, item_id: id }
            ]
            setTempChipList(tempChipList, tempChipList.business_process_id);
        }
    } else if (catName === "Automation Type") {
        if (!filter?.automation_type_id) {
            copyFilter = { ...copyFilter, automation_type_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                automation_type_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.automation_type_id = [...copyFilter.automation_type_id, id]
            setFilter(copyFilter, copyFilter.automation_type_id);
            tempChipList.automation_type_id = [
                ...tempChipList.automation_type_id,
                {
                    item_name: item.name,
                    item_id: id,
                },
            ]
            setTempChipList(tempChipList, tempChipList.automation_type_id);
        }
    } else if (catName === "Security Stage") {
        if (!filter?.security_stage_id) {
            copyFilter = { ...copyFilter, security_stage_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                security_stage_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.security_stage_id = [...copyFilter.security_stage_id, id]
            setFilter(
                copyFilter,
                copyFilter.security_stage_id
            );
            tempChipList.security_stage_id = [
                ...tempChipList.security_stage_id,
                {
                    item_name: item.name,
                    item_id: id,
                },
            ]
            setTempChipList(
                tempChipList,
                tempChipList.security_stage_id
            );
        }
    } else if (catName === "Application") {
        if (!filter?.application_id) {
            copyFilter = { ...copyFilter, application_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                application_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.application_id = [...copyFilter.application_id, id]
            setFilter(
                copyFilter,
                copyFilter.application_id
            );
            tempChipList.application_id = [
                ...tempChipList.application_id,
                {
                    item_name: item.name,
                    item_id: id,
                },
            ]
            setTempChipList(
                tempChipList,
                tempChipList.application_id
            );
        }
    }
    return copyFilter;
};
export const isUnChecked = (
    catName,
    id,
    setFilter,
    filter,
    setTempChipList,
    tempChipList
) => {
    let copyFilter = { ...filter };
    if (catName === "Category") {
        const tempArr = filter?.category_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList?.category_id?.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.category_id;
            delete tempChipList.category_id;
            setFilter(copyFilter);
            setTempChipList(tempChipList);
        } else {
            copyFilter.category_id = tempArr
            setFilter(copyFilter, copyFilter.category_id);
            tempChipList.category_id = tempFilterTagArr
            setTempChipList(
                tempChipList,
                tempChipList.category_id
            );
        }

    } else if (catName === "Business Process") {
        const tempArr = filter?.business_process_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList?.business_process_id?.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.business_process_id;
            delete tempChipList.business_process_id;
            setFilter(copyFilter);
            setTempChipList(tempChipList);
        } else {
            copyFilter.business_process_id = tempArr
            setFilter(copyFilter, copyFilter.business_process_id);
            tempChipList.business_process_id = tempFilterTagArr
            setTempChipList(
                tempChipList,
                tempChipList.business_process_id
            );
        }
    } else if (catName === "Automation Type") {
        const tempArr = filter?.automation_type_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList?.automation_type_id?.filter(
            (item) => item.item_id !== id
        );

        if (tempArr?.length === 0) {
            delete copyFilter.automation_type_id;
            delete tempChipList.automation_type_id;
            setFilter(copyFilter);
            setTempChipList(tempChipList);
        } else {
            copyFilter.automation_type_id = tempArr
            setFilter(copyFilter, copyFilter.automation_type_id);
            tempChipList.automation_type_id = tempFilterTagArr
            setTempChipList(
                setTempChipList,
                tempChipList.automation_type_id
            );
        }
    } else if (catName === "Security Stage") {
        const tempArr = filter?.security_stage_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList.security_stage_id.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.security_stage_id;
            delete tempChipList.security_stage_id;
            setFilter(copyFilter);
            setTempChipList(tempChipList);
        } else {
            copyFilter.security_stage_id = tempArr
            setFilter(copyFilter, copyFilter.security_stage_id);
            tempChipList.security_stage_id = tempFilterTagArr
            setTempChipList(
                tempChipList,
                tempChipList.security_stage_id
            );
        }
    } else if (catName === "Application") {
        const tempArr = filter?.application_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList.application_id.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.application_id;
            delete tempChipList.application_id;
            setFilter(copyFilter);
            setTempChipList(tempChipList);
        } else {
            copyFilter.application_id = tempArr
            setFilter(copyFilter, copyFilter.application_id);
            tempChipList.application_id = tempFilterTagArr
            setTempChipList(
                tempChipList,
                tempChipList.application_id
            );
        }
    }
    return copyFilter;
};

export const isActionValueController = (values) => {
    let val1 = Object.entries(values);
    return val1.map(function (item) {
        if (item[0] === 'sys_action_fields' && item[1].value) {
            const isOk = isActionValueController(item[1].value)
            if (isOk.indexOf(false) !== -1) {
                return false;
            }
        }
        if (item[1].isRequired) {
            if (item[1].value !== null && item[1].value) {
                return item[1].value.length > 0 || item[1].value || !item[1].value;
            } else {
                return false;
            }
        }
    });
};

export const valueController = (state, isControlArray) => {
    let elem;
    for (const item of state) {
        if (item["fields"] !== undefined) {
            elem = document.getElementById("flow-warning" + item.id);
            let val = isActionValueController(item.fields);
            if (val.indexOf(false) !== -1) {
                isControlArray.push(false);
                if (elem) elem.style = "visibility:visible";
            } else if ('children' in item) {
                valueController(item.children, isControlArray);
            } else {
                isControlArray.push(true);
                if (elem) elem.style = "visibility:hidden";
            }
        } else if ('children' in item) {
            valueController(item.children, isControlArray);
        } else if (item.name !== 'START' && elem) elem.style = "visibility:visible";
    }


    return isControlArray;
};

/**
 * @Description sort order data edit
 * @Param       operation_status : ipaas or rpa
 * @Param       data :  data is a pending or inprogress data
 * @Param       clickIndex : clicked data index
 * @Param       operation : clicked button "up" or "down"
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function handleSortOrder(operation_status, data, clickIndex, operation) {
    // check ipaas or rpa
    const operationType = localStorage.getItem("pf");
    //initial Data
    const orders = [];
    //click up button
    if (operation === "up") {
        orders.push(
            {
                id: data[clickIndex]?.id,
                queue_order: data[clickIndex]?.queue_order - 1,
            },
            {
                id: data[clickIndex - 1]?.id,
                queue_order: data[clickIndex]?.queue_order,
            }
        );
        const itemNow = data[clickIndex];
        const itemChange = data[clickIndex + 1];
        //swap data undefined control
        if (itemNow && itemChange) {
            //we swap data
            data[clickIndex] = itemChange;
            data[clickIndex - 1] = itemNow;
        }
    }
    //click down button operation is 'down'
    else {
        orders.push(
            {
                id: data[clickIndex]?.id,
                queue_order: data[clickIndex]?.queue_order + 1,
            },
            {
                id: data[clickIndex + 1]?.id,
                queue_order: data[clickIndex]?.queue_order,
            }
        );
        const itemNow = data[clickIndex];
        const itemChange = data[clickIndex + 1];
        //swap data undefined control
        if (itemNow && itemChange) {
            //we swap data
            data[clickIndex] = itemChange;
            data[clickIndex + 1] = itemNow;
        }
    }

    return {
        operation_status: operation_status.toUpperCase(),
        operationType,
        orders
    };
}

/**
 * @Description formating time
 * @Param       sec : seconds
 * @Returns     string
 * @Author      ibrahim AKIN
 */
export function SecFormatter(sec) {
    /* extend the String by using prototypical inheritance */
    let seconds = parseInt(sec, 10); // don't forget the second param
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - (hours * 3600)) / 60);
    seconds = seconds - (hours * 3600) - (minutes * 60);
    let time = '';  // = hours+':'+minutes+':'+seconds;
    if (hours > 0) {
        time += hours + 'h ';
    }
    if (hours > 0 || minutes > 0) {
        time += minutes + 'm ';
    }
    if (seconds > 0) {
        time += seconds + 's';
    }
    return time;
}


/**
 * @Description convert byte to size
 * @Param      bytes : byte value
 * @Returns     number
 * @Author      Kerem Karadeniz
 */
export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * @Description email control
 * @Param       email : text
 * @Returns     text
 * @Author      Kerem Karadeniz
 */

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

/**
 * @Description sort object key
 * @Param       object , key
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function sortObjects(object, key) {
    object.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0)
}

/**
 * @Description set object order  sort
 * @Param       state
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function changeOrder(mainState, order) {
    let newOrder = order ? order : 0;
    const promise = mainState?.map((item) => {
        return new Promise((resolve) => {
            if (item.actionName !== "TRIGGER") {
                if ('children' in item) {
                    item.order = newOrder;
                    newOrder++;
                    newOrder = changeOrder(item.children, newOrder);
                } else {
                    item.order = newOrder;
                    newOrder++;
                }
            }
            resolve(true);
        });
    });

    Promise.all(promise);
    return newOrder;
}

/**
 * @Description set debug array
 * @Param       state
 * @Returns     object
 * @Author      Kerem Karadeniz
 */

export function handleDebugArray(datas) {
    return new Promise(async (resolve, reject) => {
        for (let i = 0; i < datas.length; i++) {
            const element = datas[i];
            if (element.isDebugging) {
                const dataL = datas.length;
                for (let index = i + 1; index < dataL; index++) {
                    datas.pop();
                }
                resolve(datas);
                break;
            } else if (element.children && element.children.length > 0) {
                const children = await handleDebugArray(element.children);
                if (children) {
                    element.children = children;
                    const dataL = datas.length;
                    for (let index = i + 1; index < dataL; index++) {
                        datas.pop();
                    }
                    resolve(datas);
                    break;
                }
            }
        }
        resolve(undefined);
    });
}

/**
 * @Description finding debug action
 * @Param       state
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function findDebugAction(nodes, debugAction) {
    for (const item of nodes) {
        if (item.isDebugging === true) {
            debugAction.push(item);
        } else if (item.acccepNewChildren === true) {
            findDebugAction(item.children, debugAction);
        }
    }
}

/**
 * @Description finding debug action
 * @Param       state
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function editDataRun(node) {
    node.map((item) => {
        if (item.acceptsNewChildren) {
            editDataRun(item.children);
        } else {
            delete item.children;
        }
        delete item.source;
        delete item.accepts;
        delete item.image;
        delete item.type;
        delete item.item;
        delete item.id;
        return item;
    });
    return node;
}

/**
 * @description generation query params
 * @returns     filter - query param as string
 * @param       obj - query param as object
 * @author      Onur DOGUCU
 */
export function queryParamGenerator(obj) {
    let filter = "?";
    let counter = 0;
    const size = Object.keys(obj).length;
    for (const key in obj) {
        if (counter === size - 1) {
            filter += `${key}=${obj[key]}`
        } else {
            filter += `${key}=${obj[key]}&`
        }
        counter++;
    }

    return filter;
}

/**
 * @description get the value from the json by using search filter value
 * @returns     any
 * @param       o - source value
 * @param       s - searching value
 * @param       v - value to match
 * @param       g - will be obtained value
 * @author      Onur DOGUCU
 */
export function getValueFromJSON(o, s, v = undefined, g = undefined) {
    if (!s) return o;
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
        if (a[i] === "*") {
            if ((i + 1) !== n) {
                o = o.find(x => x[a[i + 1]] === v);

            }
        } else {
            let k = a[i];
            if (o && k in o) {
                if (g && g === "*") {
                    return o;
                } else {
                    o = o[k];
                }
            } else {
                return;
            }
        }

    }

    return o;
}

/**
 * This function get variable array match. Exp: ##test[0][name]## => ##test[0][name]##, test, 0, name
 * @param     {string}  value
 * @returns   {array}
 * @Author      Abdullah Onur Yeşil
 */
export function GetVariableArrayMatch(value) {
    let count = (value.match(/\[/g) || []).length;
    let exp = `##(.*)`;
    for (let i = 0; i < count; i++) {
        exp += `\\[(.*)]`
    }
    exp += "##"
    return value.match(exp)
}

export async function GenerateJWTToken(payload) {
    return await AuthService.oAuthGenerate(payload);
}

/**
 * this function converts column index to letter
 * @param     {number}  num
 * @returns   {string}
 * @Author      Abdullah Onur Yeşil
 */
export function numberToLetters(num) {
    let letters = ''
    while (num >= 0) {
        letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
        num = Math.floor(num / 26) - 1
    }
    return letters
}

/**
 * this function converts letters to column number. Not column index
 * @param     {string}  val
 * @returns   {number}
 * @Author      Abdullah Onur Yeşil
 */
export function lettersToNumber(val) {
    var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i, j, result = 0;

    for (i = 0, j = val.length - 1; i < val.length; i += 1, j -= 1) {
        result += Math.pow(base.length, j) * (base.indexOf(val[i]) + 1);
    }

    return result;
};
export function ConvertJSONtoQueryString(data) {
    const searchParams = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
        searchParams.append(key, value);
    });

    return searchParams.toString();
}

export function checkIsDate(date) {
    let isDate;
    isDate = moment(date, [
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'MM/DD/YYYY',
        'YYYY-MM-DDTHH:mm:ssZ',
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
    ], true).isValid();
    if (!isDate) {
        isDate = moment(date, [
            'YYYY-MM-DD HH:mm:ss',
            'DD/MM/YYYY HH:mm:ss',
            'MM/DD/YYYY HH:mm:ss',
            'YYYY-MM-DDTHH:mm:ssZ',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
        ], true).isValid();
    }

    return isDate;
}

export function checkSpecialCharacter(v) {
    let regex = /^[A-Za-z0-9_-]*$/;
    return v.search(regex)
}

export function getImageColors(img, callback) {
    if (img) {
        let base_image = new Image();
        // set src with library image
        base_image.src = img;

        base_image.onload = function () {
            // create canvas
            const canvas = document.createElement('canvas');
            canvas.width = base_image.width;
            canvas.height = base_image.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(base_image, 0, 0);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            // Sum the color values of all non-transparent pixels
            let red = 0;
            let green = 0;
            let blue = 0;
            let pixelCount = 0;

            for (let i = 0; i < data.length; i += 4) {
                const alpha = data[i + 3];
                if (alpha > 0) {
                    red += data[i];
                    green += data[i + 1];
                    blue += data[i + 2];
                    pixelCount++;
                }
            }

            // Get the average color of all non-transparent pixels
            if (pixelCount > 0) {
                red = Math.floor(red / pixelCount);
                green = Math.floor(green / pixelCount);
                blue = Math.floor(blue / pixelCount);
            }

            // set dynamic colors
            let background = `rgb(${red}, ${green}, ${blue})`;
            let color = getContrastingColor(background);
            callback({ background, color });
            // setDynamicBackgrounColor(`rgb(${red}, ${green}, ${blue})`);
            // setDynamicColor(getContrastingColor(background));
        }
    } else {
        callback({ background: '#666469', color: 'white' });
    }
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Function to calculate the perceived brightness of a color
function getLuma(color) {
    const [r, g, b] = color.match(/\d+/g).map(n => Number(n));
    return (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
}

// Function to get contrasting color
function getContrastingColor(color) {
    const luma = getLuma(color);
    return luma > 186 ? '#000000' : '#ffffff';
}

export function getShade(color, shade) {
    let r, g, b;

    if (color.match(/^rgb/)) {
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        r = parseInt(color[1]);
        g = parseInt(color[2]);
        b = parseInt(color[3]);
    } else {
        color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }

    r = Math.min(Math.max(0, r + shade), 255);
    g = Math.min(Math.max(0, g + shade), 255);
    b = Math.min(Math.max(0, b + shade), 255);

    return `rgb(${r}, ${g}, ${b})`;
}